import React from 'react';
import { Sparkles, Mail, Github, Heart } from 'lucide-react';
import { Link } from 'react-router-dom';

export const Footer: React.FC = () => {
  const currentYear = new Date().getFullYear();

  const links = [
    { name: '关于我们', href: '/about' },
    { name: '教程投送', href: '/submission' },
    { name: '联系我们', href: '/contact' },
    { name: '免责声明', href: '/disclaimer' },
  ];

  return (
    <footer className="border-t bg-muted/30 pt-12 pb-8">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          <div className="col-span-1 md:col-span-2">
            <Link to="/" className="flex items-center gap-2 font-bold text-xl tracking-tight mb-4">
              <div className="bg-primary p-1.5 rounded-lg">
                <Sparkles className="h-5 w-5 text-primary-foreground" />
              </div>
              <span className="gradient-text">万象聚聚光2135c</span>
            </Link>
            <p className="text-muted-foreground text-sm max-w-sm mb-6">
              面向自媒体创作者的全流程教程聚合导航网站，帮助创作者高效找到所需学习资源。
            </p>
            <div className="flex gap-4">
              <Github className="h-5 w-5 text-muted-foreground hover:text-primary cursor-pointer transition-colors" />
              <Mail className="h-5 w-5 text-muted-foreground hover:text-primary cursor-pointer transition-colors" />
            </div>
          </div>

          <div>
            <h4 className="font-bold text-sm uppercase tracking-wider mb-4">常用链接</h4>
            <ul className="space-y-3">
              {links.map((link) => (
                <li key={link.name}>
                  <Link to={link.href} className="text-sm text-muted-foreground hover:text-primary transition-colors">
                    {link.name}
                  </Link>
                </li>
              ))}
              <li>
                <Link to="/resources" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  资源导航
                </Link>
              </li>
              <li>
                <Link to="/unlock" className="text-sm text-amber-600 dark:text-amber-400 hover:text-amber-700 dark:hover:text-amber-300 transition-colors font-medium">
                  高级解锁
                </Link>
              </li>
              <li>
                <Link to="/support" className="text-sm text-muted-foreground hover:text-primary transition-colors">
                  客服申诉
                </Link>
              </li>
            </ul>
            
            {/* 内测入口 */}
            <div className="mt-6 p-4 bg-gradient-to-br from-primary/10 to-secondary/10 rounded-lg border border-primary/20">
              <div className="flex items-start gap-2 mb-2">
                <Sparkles className="h-4 w-4 text-primary mt-0.5 shrink-0" />
                <div>
                  <h5 className="font-bold text-sm text-primary mb-1">星光科技万象聚聚呀 3.0</h5>
                  <p className="text-xs text-muted-foreground mb-3">限量招募 1000 名内测会员</p>
                  <a 
                    href="https://app-ae1hdzbgd3pd.appmiaoda.com/" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-1 text-xs font-medium text-primary hover:text-primary/80 transition-colors"
                  >
                    立即加入内测 →
                  </a>
                </div>
              </div>
            </div>
            
            {/* 手机版入口 */}
            <div className="mt-4 p-4 bg-gradient-to-br from-purple-500/10 to-pink-500/10 rounded-lg border border-purple-500/20">
              <div className="flex items-start gap-2">
                <Sparkles className="h-4 w-4 text-purple-600 mt-0.5 shrink-0" />
                <div>
                  <h5 className="font-bold text-sm text-purple-600 mb-1">万象聚聚光手机版</h5>
                  <p className="text-xs text-muted-foreground mb-3">多模态AI创作，手机端轻量化操作</p>
                  <a 
                    href="https://app-ahdlksff6329.appmiaoda.com" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-1 text-xs font-medium text-purple-600 hover:text-purple-600/80 transition-colors"
                  >
                    立即体验 →
                  </a>
                </div>
              </div>
            </div>
            
            {/* 星光科技聚合站 */}
            <div className="mt-4 p-4 bg-gradient-to-br from-amber-500/10 to-orange-500/10 rounded-lg border border-amber-500/20">
              <div className="flex items-start gap-2">
                <Sparkles className="h-4 w-4 text-amber-600 mt-0.5 shrink-0" />
                <div>
                  <h5 className="font-bold text-sm text-amber-600 mb-1">星光科技聚合型综合站</h5>
                  <p className="text-xs text-muted-foreground mb-3">全方位AI工具聚合平台</p>
                  <a 
                    href="https://app-ahdkin5wsrup.appmiaoda.com" 
                    target="_blank" 
                    rel="noopener noreferrer"
                    className="inline-flex items-center gap-1 text-xs font-medium text-amber-600 hover:text-amber-600/80 transition-colors"
                  >
                    立即访问 →
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div>
            <h4 className="font-bold text-sm uppercase tracking-wider mb-4">友情链接</h4>
            <ul className="space-y-3">
              <li>
                <a href="https://lv.ulikecam.com" target="_blank" className="text-sm text-muted-foreground hover:text-primary transition-colors">剪映官方</a>
              </li>
              <li>
                <a href="https://school.douyin.com" target="_blank" className="text-sm text-muted-foreground hover:text-primary transition-colors">抖音创作者学院</a>
              </li>
              <li>
                <a href="https://www.newrank.cn" target="_blank" className="text-sm text-muted-foreground hover:text-primary transition-colors">新榜</a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-xs text-muted-foreground">
            © {currentYear} 万象聚聚光2135c. All rights reserved.
          </p>
          <p className="text-xs text-muted-foreground flex items-center gap-1">
            Made with <Heart className="h-3 w-3 text-red-500 fill-current" /> for Creators
          </p>
        </div>
      </div>
    </footer>
  );
};
